import { fromJS, isKeyed } from 'immutable';

import { ACTION_TYPES } from './actions';

const initialState = {
    eventMap: fromJS({}),
}

const updateEvent = (eventMap, {ravenUuid, event}) => {
    return eventMap.mergeDeepIn([ravenUuid, event.eventId], fromJS(event, eventFromJSReviver));
};

const eventFromJSReviver = (key,value) => key === 'mediaIds'
    ? value.toSet()
    : (isKeyed(value)
        ? value.toMap()
        : value.toList()
    );

const addAllEvents = (eventMap, {ravenUuid, eventList}) => {
    return eventMap.withMutations(map =>
        eventList.forEach(event =>
            map.mergeDeepIn([ravenUuid, event.eventId], fromJS(event, eventFromJSReviver))
        )
    );
};

export default function(state = initialState, action) {

    let ravenUuid, eventId, mediaId, request, timeoutId, error, statusEventType, statusEventTimestamp;

    switch (action.type) {

        case ACTION_TYPES.ADD_ALL_EVENTS:
            return {
                eventMap: addAllEvents(state.eventMap, action.payload)
            };

        case ACTION_TYPES.UPDATE_EVENT:
            return {
                eventMap: updateEvent(state.eventMap, action.payload)
            };

        case ACTION_TYPES.ADD_MEDIA_ID_TO_EVENT:
            ravenUuid = action.payload.ravenUuid;
            eventId = action.payload.eventId;
            mediaId = action.payload.mediaId;
            return {
                eventMap: updateEvent(state.eventMap,
                    {
                        ravenUuid,
                        event: {
                            eventId,
                            mediaIds: [mediaId]
                        }
                    }
                )
            };

        case ACTION_TYPES.CLEAR_REQUEST_EVENT_USER_VIDEO_FROM_RAVEN:
            ravenUuid = action.payload.ravenUuid;
            eventId = action.payload.eventId;
            return {
                eventMap: updateEvent(state.eventMap, {
                    ravenUuid,
                    event: {
                        eventId,
                        userMediaRequest: {
                            request: null,
                            error: null,
                            timeoutId: null,
                            statusEventType: null,
                            statusEventTimestamp: null
                        }
                    }
                })
            };

        case ACTION_TYPES.REQUEST_EVENT_USER_VIDEO_FROM_RAVEN: // sets userMediaRequest, clears error
            ravenUuid = action.payload.ravenUuid;
            eventId = action.payload.eventId;
            request = action.payload.request;
            timeoutId = action.payload.timeoutId;
            return {
                eventMap: updateEvent(state.eventMap, {
                    ravenUuid,
                    event: {
                        eventId,
                        userMediaRequest: {
                            request: request,
                            error: null,
                            timeoutId: timeoutId,
                            statusEventType: null,
                            statusEventTimestamp: null
                        }
                    }
                })
            };

        case ACTION_TYPES.REQUEST_EVENT_USER_VIDEO_FROM_RAVEN_UPDATE_STATUS:
            ravenUuid = action.payload.ravenUuid;
            eventId = action.payload.eventId;
            statusEventType = action.payload.statusEventType;
            statusEventTimestamp = action.payload.statusEventTimestamp;
            timeoutId = action.payload.statusUpdateTimeoutId;
            return {
                eventMap: updateEvent(state.eventMap, {
                    ravenUuid,
                    event: {
                        eventId,
                        userMediaRequest: {
                            timeoutId: timeoutId,
                            statusEventType: statusEventType,
                            statusEventTimestamp: statusEventTimestamp
                        }
                    }
                })
            };

        case ACTION_TYPES.REQUEST_EVENT_USER_VIDEO_FROM_RAVEN_ERROR: // sets error AND status for error
            // clear userMediaRequest, set error
            ravenUuid = action.payload.ravenUuid;
            eventId = action.payload.eventId;
            statusEventType = action.payload.statusEventType;
            error = action.payload.error;
            return {
                eventMap: updateEvent(state.eventMap, {
                    ravenUuid,
                    event: {
                        eventId,
                        userMediaRequest: {
                            // request property is not cleared here (see EVENT_MEDIA_UPLOAD_COMPLETED event in actions or errors or timeouts)
                            error: error,
                            statusEventType: statusEventType
                        }
                    }
                })
            };

        case ACTION_TYPES.REQUEST_EVENT_USER_VIDEO_FROM_RAVEN_SUCCESS: // does nothing
            // (request sent) subsequent "success" tasks handled on incoming mqtt events associated with this request
            return state;

        default:
            return state;
    }
};
